import { AddonRegistrationModel } from '@/components/addons/registration/Model';
import { FormElementModel } from '@/components/addons/registration/types';
import { ContentAddonType } from '@/components/layout/column/ColumnModel';
import { SdkBaseAddonModel } from '.';
import { SdkFormFieldModel } from '../formField';

export class SdkAddonRegistration extends SdkBaseAddonModel {
  #formFields: FormElementModel[] | undefined;

  constructor(model: ContentAddonType) {
    super(model);
    if (model instanceof AddonRegistrationModel) {
      this.#formFields = model.state.fields;
    }
  }

  get formFields() {
    if (this.#formFields) {
      return this.#formFields.map((field) => new SdkFormFieldModel(field)) ?? [];
    }
    return [];
  }
}
